import { ConferencePageComponent } from "./conference-page.component";
import { ConferenceModule } from "./conference/conference.module";
export var ConferencePageModule = angular
    .module('conferencePage', [ConferenceModule])
    .config(['$stateProvider', function ($stateProvider) {
        $stateProvider.state('conference', {
            url: '/conference?c&j&jm&t&mode&sh&ws&m',
            component: ConferencePageComponent.selector,
            data: {
                requireLogin: true
            },
            params: {
                candidateId: null,
                jobId: null,
                jobMatchId: null
            }
        });
    }
])
    .component(ConferencePageComponent.selector, ConferencePageComponent.component)
    .name;
//# sourceMappingURL=conference-page.module.js.map